import { House, SuitcaseRolling } from "@phosphor-icons/react"
import { generateLocationLink } from "@/lib/google-maps"
import { NO_INFORMATION } from "@/modules/patients/agenda/teleconsultation/booking/address-section"
import { getTranslatedCountry } from "@/modules/patients/libs/get-translated-country"
import { PatientFragment$data } from "@/modules/patients/services/__generated__/PatientFragment.graphql"

type Address = PatientFragment$data["address"]

type Props = {
  address: NonNullable<Address>
  hasManuallyAddedAddress?: boolean
}

const AddressLink = ({ address, hasManuallyAddedAddress }: Props) => {
  const { country, postalCode, city, houseNumberStreet } = address

  const formattedAddress = [houseNumberStreet, postalCode, city, getTranslatedCountry(country)]
    .filter((v) => v && v !== NO_INFORMATION)
    .join(" ")

  const googleLink = generateLocationLink(formattedAddress)

  const displayAddress = [country?.code, postalCode]
    .filter((address) => Boolean(address) && address !== NO_INFORMATION)
    .join("-")

  return (
    <a
      className="text-primary flex underline"
      rel="noreferrer"
      href={googleLink}
      target="_blank"
      data-testid="patient-address-google-map-link">
      {hasManuallyAddedAddress ? (
        <SuitcaseRolling size={20} data-testid="suitecase-icon" />
      ) : (
        <House size={20} data-testid="house-icon" />
      )}
      {displayAddress}
    </a>
  )
}

export { AddressLink }
